import PageItemWrapper, { IPageItemattributes } from '../page-item-wrapper/page-item-wrapper';
import IconPrevPage from '../../../../../icons/icon-prev-page/icon-prev-page';
import Button from '../button/button';
import { IPaginationButtonProps } from '../../../../table.types';
import Icon from '../../../../../icons/icon/icon';

const Prev: React.FC<IPaginationButtonProps> = ({ isActive, onClick, activeColor }) => {
    const attributes: IPageItemattributes = { 'aria-label': '« Previous' }
    const classList: string[] = ['prev'];
    if (!isActive) {
        attributes['aria-disabled'] = true;
        classList.push('disabled')
    }
    return (
        <PageItemWrapper {...attributes} classList={classList}>
            {isActive ?
                <Button onClick={onClick} label="« Previous">
                    <Icon Component={IconPrevPage} color={activeColor} />
                </Button> :
                <span className="page-link" aria-disabled="true">
                    <Icon Component={IconPrevPage} disabled />
                </span>
            }
        </PageItemWrapper>
    )
}

export default Prev;
